import { render, staticRenderFns } from "./EmployeeVacationDayWidget.vue?vue&type=template&id=234c990d&scoped=true&"
import script from "./EmployeeVacationDayWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeVacationDayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c990d",
  null
  
)

export default component.exports